import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Footer from 'components/common/Footer/Footer';
import HeaderLogo from 'components/common/HeaderLogo/HeaderLogo';
import ExternalClientAccessInfo from 'components/common/ExternalClientAccessInfo/ExternalClientAccessInfo';
import Summary from 'components/common/Summary/Summary';
import Carousel from 'components/Step4/Carousel';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'store/actions';
import { updateNA, updateExternalAccessNA } from 'store/na/thunk';
import styles from './step4.module.scss';
import { useTranslation } from 'react-i18next';
import { weakKey } from 'utils/objects';
import searchParams from 'constants/searchParams';
import paths from 'constants/paths';
import { useStepsWizard } from 'hooks/useStepsWizard';

export default function Step4() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);
  const preview = params.get(searchParams.preview);
  const na = useSelector((state) => state.na);
  const spaces = useSelector((state) => state.na.spaces);
  const workplacestyleSelected = useSelector((state) => state.na.workplacestyleSelected);
  const isExternalAccess = useSelector((state) => state.general.isExternalAccessMode);
  const isReadOnlyMode = useSelector((state) => state.general.isReadOnlyMode);
  const externalAccessConfig = useSelector((state) => state.externalAccessConfig);
  const { goToStep } = useStepsWizard({
    naId: na.id,
    preview,
    isExternalAccess,
    accessKey: externalAccessConfig.accessKey,
  });

  const handleChangeWorkplace = (selectedWorkplaceStyle) => {
    if (isReadOnlyMode) return;
    if (selectedWorkplaceStyle !== na.workplacestyleSelected) {
      dispatch(actions.na.updateWorkplaceStyleSelected(Number(selectedWorkplaceStyle)));
      dispatch(isExternalAccess ? updateExternalAccessNA({ hasChanged: true }) : updateNA);
    }
  };

  const updateDataStore = (step) => {
    if (!isReadOnlyMode) {
      dispatch(actions.na.updateLastStep(step));
      dispatch(isExternalAccess ? updateExternalAccessNA({ hasChanged: false }) : updateNA);
    }
  };

  const handleNext = () => {
    updateDataStore(paths.steps.customizeBuildOut);
    goToStep({ step: paths.steps.customizeBuildOut });
  };
  const handleBack = () => {
    updateDataStore(paths.steps.yourGrowth);
    goToStep({ step: paths.steps.yourGrowth });
  };

  return (
    <>
      {isReadOnlyMode && !isExternalAccess && <ExternalClientAccessInfo />}
      <div className={styles.container}>
        <div className={styles.column1}>
          <HeaderLogo />
          <div className={styles.row2}>
            <div className={styles.title}>{t('step4.title')}</div>
            <div className={styles.description}>{t('step4.description')}</div>
            <div className={styles.stepper}>
              {Array.isArray(spaces)
                ? spaces.map((space, index) => (
                    <div
                      data-testid={`Step4SpacesTypes-${index}`}
                      key={weakKey(space)}
                      className={styles.workplace_style_option}
                      onClick={() => handleChangeWorkplace(Number(space.id))}>
                      <Carousel
                        grayscale={workplacestyleSelected !== space.id}
                        images={space.imageUrls}
                        space={space}
                      />
                      <FormControl disabled={isReadOnlyMode} className={styles.space_radio_button}>
                        <FormControlLabel
                          data-testid={`Step4FormControl-${index}`}
                          control={<Radio />}
                          label={t(space.name)}
                          value={space.id}
                          checked={workplacestyleSelected === space.id}
                          onChange={() => handleChangeWorkplace(Number(space.id))}
                        />
                      </FormControl>
                      <ul className={styles.space_description}>
                        {t(space.description)
                          .split('\\n')
                          .map((text, idx) => (
                            <li key={'spaces-description-' + idx}>{text}</li>
                          ))}
                      </ul>
                    </div>
                  ))
                : []}
            </div>
          </div>
          <div className={styles.row3}>
            <Footer
              title={t('step4.footerTitle')}
              description={t('step4.footerDescription')}
              stepsHighlighted="4"
              handleback={handleBack}
              handlenext={handleNext}></Footer>
          </div>
        </div>
        <div className={styles.column2}>
          <Summary office_type_id={workplacestyleSelected} />
        </div>
      </div>
    </>
  );
}
